import React, { useReducer, useContext ,createContext} from 'react';
let initialState = {
    tableKeys:[],
    tableData:[],
    key_name:[],
    currentList:[]
    
  };
  export const AppContext = createContext();

  export const AppContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const value = { ...state, dispatch };

  
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
  };
  
  export const useAppContext = () => useContext(AppContext);
  const reducer=(state,action)=>{
      let new_state=null;
      const initialState={
        tableKeys:[],
        tableData:[],
        key_name:[],
        
      };
      switch(action.type){
          case ContextConstants.getKeys:{
              new_state ={...state}
              new_state.key_name=action.payload
              return new_state
          }
          case ContextConstants.add:{
              new_state={...state}
              new_state.tableData=action.payload
              return new_state
          }
          case ContextConstants.removetransporter:{
            new_state={...state}

            return {...state,tableData:action.payload}
          }
          case ContextConstants.setTableKeys:{
            new_state={...state}
            new_state.tableKeys=action.payload
            return new_state
          }
          case ContextConstants.addTransportertoList:{
            new_state={...state}
            new_state.currentList=action.payload
            return new_state
          }
          case ContextConstants.removeTransporterFromList:{
            new_state={...state}
            new_state.currentList=action.payload
            return new_state
          }
          case ContextConstants.resetState:{
           let list=state.currentList
           return {...initialState,currentList:list}
          }
          default:{
            return state
            }
            
      }
      
     
  }
  export const ContextConstants={
      getKeys:'getKeys',
      add:'add',
      removetransporter:'remove_transporter',
      setTableKeys:'setKeys',
      addTransportertoList:'addTransporter',
      resetState:'reset',
      removeTransporterFromList:'removeTransporter'
  }